//@ts-nocheck
import "./content.css";
import clsx from "clsx";
import { Redirect } from "../router";
import React, { useEffect, useRef } from "react";
import ArcAnalytics from "../ARCAnalytics/arcAnalytics";
import { useLocation } from "../../hooks/router/useLocation";
import Route from "../../lib/route/route";
import autoAnimate from "@formkit/auto-animate";
import useWindowSize from "../../hooks/sizeListener/useSizeListener";

type ContentType = {
  children: React.ReactNode;
  className?: string | object;
};

export default function Content(props: ContentType) {
  const { children, className } = props;

  const location = useLocation();

  const parentRef = useRef(null);

  useEffect(() => {
    autoAnimate(parentRef.current);
  }, [parentRef]);

  //todo:برای رفع مشکل روتر اضافه شده
  /*  let convert = "";
  if (!location.pathname.includes("ARC")) {
    debugger;
    if (location.pathname && location.pathname.includes("?app")) {
      const searchVar = getSearchVars(
        `${location.pathname}${location.search || ""}`
      );
      const vars = getSearchVarsArray(
        `${location.pathname}${location.search || ""}`
      );
      let newTo = `/ARC`;

      if (!location.pathname.includes("hashCode")) {
        const r = Route.builder({ data: vars, to: "normal" });
        console.log(vars, r);
        for (let i = 0; i < vars.length; i++) {
          if (typeof vars[i] === "string") {
            newTo += `/${vars[i]}`;
          }
        }
      } else {
        newTo += `/${searchVar.app}/${searchVar.view}/${searchVar?.ID}/${searchVar.hashCode}`;
      }

      if (
        location.pathname?.includes("app=shop") &&
        location.pathname?.includes("view=receipt")
      ) {
        newTo = `/ARC/${searchVar.app}/${searchVar.view}?`;
        for (let i in searchVar) {
          if (i !== "app" && i !== "view") {
            newTo += `${i}=${searchVar[i]}&`;
          }
        }
        if (newTo[newTo.length - 1] === "&") {
          newTo = newTo.substring(0, newTo.length - 1);
        }
      }
      convert = newTo;
    }
  }*/

  const convert = Route.toNormalRoute(location);

  useEffect(() => {
    if (_Params?.googleTagIDs && _Params?.googleTagIDs[_CID]) {
      setPreviewAnalytic(_Params?.googleTagIDs[_CID]);
    }
    if (_Params?.gandomTagIDs && _Params?.gandomTagIDs[_CID]) {
      setPreviewAnalytic(_Params?.gandomTagIDs[_CID]);
    }


  }, [location]);

  function setPreviewAnalytic(id) {
    const analyticObj = new ArcAnalytics({ id });
    analyticObj.init();
    analyticObj.preview({ page: location.pathname, title: "ARC" });
  }

  const { bootstrapSize } = useWindowSize({});
  const key = location?.pathname === "/" ? "frontpage" : "contentpage";
  let custom = _TemplateConfig?.[key]?.content?.For?.[bootstrapSize]?.style || {};

  const style =
    location?.pathname === "/"
      ? _TemplateConfig?.[key]?.content?.style
      : _TemplateConfig?.[key]?.content?.style;

  return (
    <React.Fragment>
      <div
        ref={parentRef}
        id="content"
        className={clsx(
          "content",
          className,
          location?.pathname === "/"
            ? _TemplateConfig?.[key]?.content?.class
            : _TemplateConfig?.[key]?.content?.class
        )}
        style={{...style, ...custom}}
      >
        {/*     <div
          className={clsx(
            "innerStart",
            _TemplateConfig?.contentpage?.innerStart?.class
          )}
        />*/}

        <div
          className={clsx(
            "innerDiv h-100",
            location?.pathname === "/"
              ? _TemplateConfig?.frontpage?.inner?.class
              : _TemplateConfig?.contentpage?.inner?.class
          )}
          style={
            location?.pathname === "/"
              ? _TemplateConfig?.frontpage?.inner?.style
              : _TemplateConfig?.contentpage?.inner?.style
          }
          id="innerDiv"
        >
          {children}
        </div>

        {/*      <div
          className={clsx(
            "innerEnd",
            _TemplateConfig?.contentpage?.innerEnd?.class
          )}
        />*/}
      </div>

      {convert ? <Redirect to={convert} /> : ""}
    </React.Fragment>
  );
}
